module.exports = __webpack_public_path__ + "assets/images/no-avatar_f9289a7534fb14baa43988b5772b08a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no-avatar.png
// module id = 388
// module chunks = 0